export default "__VITE_ASSET__TIzZOcvZ__"